import React from 'react'
import {
  ButtonSizeEnum,
  GrayIconButton,
} from 'src/editor/shared/ui-lib/buttons'
import { MinusIcon } from 'src/editor/shared/icons/minus-icon'
import { PlusIcon } from 'src/editor/shared/icons/plus-icon'

interface FormSubentityNumberInputProps {
  max?: number
  value: number
  onChange: (value: number) => void
}

export const FormSubentityNumberInput = ({
  max = 5,
  value,
  onChange,
}: FormSubentityNumberInputProps) => {
  return (
    <div className="flex items-center gap-3">
      {value > 0 && (
        <>
          <GrayIconButton
            size={ButtonSizeEnum.Small}
            icon={<MinusIcon />}
            onClick={() => onChange(value - 1)}
          />
          <span className="min-w-[1ch] text-M text-textPrimary">{value}</span>
        </>
      )}

      <GrayIconButton
        size={ButtonSizeEnum.Small}
        icon={
          <PlusIcon className="[&>path]:fill-iconSecondary [&>path]:stroke-iconSecondary!" />
        }
        disabled={value >= max}
        onClick={() => value < max && onChange(value + 1)}
      />
    </div>
  )
}
